function withTrailingSlash(value) {
  const trimmed = String(value).trim();
  return trimmed.endsWith("/") ? trimmed : `${trimmed}/`;
}

function resolveLocation(locationOrHost) {
  if (locationOrHost == null) {
    return {
      protocol: window.location.protocol,
      host: window.location.host,
    };
  }
  if (typeof locationOrHost === "string") {
    return {
      protocol:
        typeof window !== "undefined" && window.location?.protocol
          ? window.location.protocol
          : "http:",
      host: locationOrHost,
    };
  }
  return {
    protocol:
      locationOrHost.protocol ||
      (typeof window !== "undefined" ? window.location.protocol : "http:"),
    host:
      locationOrHost.host ||
      locationOrHost.hostname ||
      (typeof window !== "undefined" ? window.location.host : "localhost"),
  };
}

function isPageHttps(locationLike) {
  return String(locationLike.protocol || "")
    .toLowerCase()
    .startsWith("https");
}

function sameOriginWsBase(locationOrHost) {
  const loc = resolveLocation(locationOrHost);
  const scheme = isPageHttps(loc) ? "wss" : "ws";
  return `${scheme}://${loc.host}/ws/`;
}

/**
 * Resolve the WebSocket base URL.
 *
 * - Default/fallback is protocol-aware same-origin: HTTPS → wss://host/ws/,
 *   HTTP → ws://host/ws/ (host includes port when present).
 * - Valid REACT_APP_WS_URL overrides are supported with trailing-slash normalize.
 * - On HTTPS pages, ws:// overrides are upgraded to wss://.
 * - Malformed or http(s) overrides fall back to same-origin without throwing.
 *
 * @param {string|{protocol?: string, host?: string, hostname?: string}} [locationOrHost]
 */
export function resolveWsBaseUrl(locationOrHost) {
  const loc = resolveLocation(locationOrHost);
  const pageHttps = isPageHttps(loc);
  const configured = process.env.REACT_APP_WS_URL;

  if (configured && String(configured).trim()) {
    const trimmed = String(configured).trim();
    try {
      const parsed = new URL(trimmed);
      if (parsed.protocol === "wss:") {
        return withTrailingSlash(trimmed);
      }
      if (parsed.protocol === "ws:") {
        if (pageHttps) {
          return withTrailingSlash(
            `wss://${parsed.host}${parsed.pathname}${parsed.search}`,
          );
        }
        return withTrailingSlash(trimmed);
      }
    } catch {
      // Malformed override — secure same-origin fallback below.
    }
    return sameOriginWsBase(loc);
  }

  return sameOriginWsBase(loc);
}

export function buildWsUrl(token, locationOrHost) {
  return `${resolveWsBaseUrl(locationOrHost)}?token=${encodeURIComponent(token)}`;
}
